<template>
    <div>
        <masternav/>
        <!--  -->
      
      <b-nav class="navlinks ">
        <b-nav-item router-link :to="{ name: 'Home'}">
          <span class="navtext ">{{$t('privacy.nav1')}}</span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item disabled>
            <span class="navtext2">{{$t('privacy.nav2')}}</span>
        </b-nav-item>
      </b-nav>
      <!--  -->
      <div class="">
        <h1 class="titlequestion ml-5 mr-5 ">{{$t('privacy.priv1')}}</h1>
        <br><br>
        <div class="ml-5 mr-5 navtext2 ">
          <p class="titleterm ">{{$t('privacy.priv2')}}</p>
          <h6>
            {{$t('privacy.priv3')}}
            </h6>
          <p class="titleterm ">{{$t('privacy.priv4')}}</p>
          <h6>
            {{$t('privacy.priv5')}}
            </h6>
          <!--  -->
          <p class="titleterm ">{{$t('privacy.priv6')}}</p>
          <h6>
            {{$t('privacy.priv7')}}
            </h6>
          <!--  -->
          <p class="titleterm ">{{$t('privacy.priv8')}}</p>
          <h6>
              {{$t('privacy.priv9')}} </h6>
          <!--  -->
          <p class="titleterm ">{{$t('privacy.priv10')}}</p>
          <h6>
              {{$t('privacy.priv11')}}
              </h6>
          <!--  -->
         {{$t('privacy.priv12')}}
         <p class="titleterm ">{{$t('privacy.priv13')}}</p>
          <h6>
              {{$t('privacy.priv14')}}
              </h6>
         {{$t('privacy.priv15')}}
         <p class="titleterm ">{{$t('privacy.priv16')}}</p>
          <h6>
          {{$t('privacy.priv17')}}
          <br>

          {{$t('privacy.priv18')}}
          </h6>

          <p class="titleterm ">{{$t('privacy.priv19')}}</p>
          <h6>
            {{$t('privacy.priv20')}}
          </h6>

          <p class="titleterm ">{{$t('privacy.priv21')}}</p>
          <h6>
            {{$t('privacy.priv22')}}
          </h6>

          <p class="titleterm ">{{$t('privacy.priv23')}}</p>
          <h6>
           {{$t('privacy.priv24')}}
           </h6>

          <p class="titleterm ">{{$t('privacy.priv25')}}</p>
          <h6>
           {{$t('privacy.priv26')}}
           </h6>

          <p class="titleterm ">{{$t('privacy.priv27')}}</p>
          <h6>
           {{$t('privacy.priv28')}}
           
           </h6>
          
          <p class="titleterm ">{{$t('privacy.priv29')}}</p>
          <h6>
           {{$t('privacy.priv30')}}
           </h6>
          
          <p class="titleterm ">{{$t('privacy.priv31')}}</p>
          <h6>
           {{$t('privacy.priv32')}}
           </h6>
          
          <p class="titleterm ">{{$t('privacy.priv33')}}</p>
          <h6>
           {{$t('privacy.priv34')}}
           </h6>
        </div>
        <br><br>
       </div>  
      <!--  -->
        <mainfooter/>
    </div>
</template>

<script>
import masternav      from '@/components/masternav.vue'
import maincontent    from '@/components/maincontent.vue'
import mainfooter     from '@/components/mainfooter.vue'
import rents          from '@/components/rents.vue'
import covidnews      from '@/components/covidnews.vue'

export default {
    name: 'Privacy',
    metaInfo: {
      title: "Enterprise Panama - Privacidad | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
    components: {
        masternav,
        mainfooter,
        maincontent,
        rents,
        covidnews
    }
}
</script>

<style lang="scss" scoped>
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.titleterm{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 18px;
   margin-top: 15px;
   margin-left: 0px;
   font-weight: 500;
   color: #333333;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
</style>